
import { requireAuth } from './auth';

const paymentURL = process.env.VUE_APP_API_PAYMENT_URL;

async function parseReferralResponse(response) {
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        const message = data?.detail?.error || data?.detail || data?.error || `Request failed with status ${response.status}`;
        throw new Error(message);
    }
    return data;
}

export async function getReferralSenderInfo() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = `${paymentURL}/frontend_query/menu`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    return parseReferralResponse(response);
}

export async function getReferralDashboard() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = `${paymentURL}/frontend_query/dashboard`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    return parseReferralResponse(response);
}
